import Axios from "axios";
import Configuration from "./Configuration";
import SessionManager, {secureApiCall} from "./SessionManager";
import { CreateGetUrl, GetUserName, CreatePostUrl, CreateMetadataUrl, CreateUserUnlockUrl } from "./HelpfulFunctions"

class DataSource {

    /**
     * 
     * @param _entityName The name of the entity to load
     * @param _pkeyValues The primary key values that identify the instance to load
     * @param _options Additional query options
     * @returns An object that corresponds to the given primary key values or null
     *          if no object is found
     */
    static async load(_entityName, _pkeyValues, _options) {
        return await secureApiCall(loadInternal, _entityName, _pkeyValues, _options);
    }

    /**
     * 
     * @param _entityName The name of the entity to query
     * @param _queryDef The query definition
     * @returns An array containing the objects / results of the query
     */
    static async query(_entityName, _queryDef) {
        return await secureApiCall(queryInternal, _entityName, _queryDef);
    }

    /**
     * 
     * @param _entityName The name of the object's entity
     * @param _domainObject the object to persist
     */
    static async persist(_entityName, _domainObject) {
        return await secureApiCall(persistInternal, _entityName, _domainObject);
    }

    static async unlockUser(_userName) {
        return await secureApiCall(unlockUserInternal, _userName);
    }
}

async function loadInternal(_entityName, _pkeyValues, _options) {
    var userName = localStorage.hasOwnProperty('userData') ? GetUserName(localStorage.getItem('userData')) : null;
    var values = null;
    var associations = null;

    if (_pkeyValues) {
        if (typeof _pkeyValues === "object")
            values = Object.values(_pkeyValues);
        else if (typeof _pkeyValues === "string")
            values = _pkeyValues;
        else
            values = _pkeyValues;
    }

    if (_options) {

        if (_options.hasOwnProperty("associations")) {
            associations = _options.associations;
        }

        if (_options.hasOwnProperty("userName"))
            userName = _options.userName;
    }

    const url = CreateGetUrl(
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version,
        /* entityName */            _entityName,
        /* pk */                    values,
        /* filter */                null,
        /* join */                  associations,
        /* select */                null,
        /* orderby */               null,
        /* count */                 null,
        /* top */                   null,
        /* authenticationToken */   localStorage.hasOwnProperty('userToken') ? SessionManager.userToken : '',
        /* username */              userName);
    
    var response = await Axios.get(url);

    if (response.data) {
        if (typeof response.data === "string") {
            let deserializedData = JSON.parse(response.data);
            return deserializedData.Results;
        }
        else {
            return response.data.Results;
        }

    }
    else {
        return null;
    }
}

async function queryInternal(_entityName, _queryDef) {

    if (!_queryDef)
        _queryDef = {};
        
    var userName = localStorage.hasOwnProperty('userData') ? GetUserName(localStorage.getItem('userData')) : null;
    if (_queryDef.hasOwnProperty("userName"))
        userName = _queryDef.userName;

    var associations;

    if (_queryDef.hasOwnProperty("join"))
        associations = _queryDef.join;
    else if (_queryDef.hasOwnProperty("associations"))
        associations = _queryDef.associations;

    const url = CreateGetUrl(
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version,
        /* entityName */            _entityName,
        /* pk */                    null,
        /* filter */                _queryDef.filter,
        /* join */                  associations,
        /* select */                _queryDef.select,
        /* orderby */               _queryDef.orderBy,
        /* count */                 _queryDef.count,
        /* top */                   _queryDef.top,
        /* authenticationToken */   localStorage.hasOwnProperty('userToken') ? SessionManager.userToken : '',
        /* username */              userName);

    var response = await Axios.get(url);

    if (response.data) {
        if (typeof response.data === "string") {
            let deserializedData = JSON.parse(response.data);
            return deserializedData.Results;
        }
        else {
            return response.data.Results;
        }
    }
    else {
        return null;
    }
}

async function persistInternal(_entityName, _data) {

    const url = CreatePostUrl(
        /* controller */            'data',
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version,
        /* entityName */            _entityName,
        /* authenticationToken */   localStorage.hasOwnProperty('userToken') ? SessionManager.userToken : '',
        /* username */              localStorage.hasOwnProperty('userData') ? GetUserName(localStorage.getItem('userData')) : '');

    var response = await Axios.post(url, _data);
    return response;
}

async function unlockUserInternal(_userName) {
    var data = {};
    var authenticationToken = localStorage.hasOwnProperty('userToken') ? SessionManager.userToken : '';
    var userName = localStorage.hasOwnProperty('userData') ? GetUserName(localStorage.getItem('userData')) : '';

    data.username = _userName;
    data.authenticationTokenKey = authenticationToken;
    data.usernameKey = userName;

    const url = CreateUserUnlockUrl(
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version
    );


    var response = await Axios.post(url, data);
    return response;
}

export default DataSource;